<template>
    <app-dialog
        :value="value"
        size="lg"
        fixed-width
        @input="emitInput"
        @close="emitClose"
    >
        <template #header>
            <span class="text-lg">
                Historial de la orden
                <span v-if="orderId" class="text-theme-primary">
                    # {{ orderId }}
                </span>
            </span>
        </template>

        <custom-table
            :fields="fields"
            :items="rows"
            outlined
            items-empty-message="Esta orden no tiene cambios registrados."
        >
            <template #cell(date)="{ item }">
                {{ item.date | date }}
            </template>
            <template #cell(oldValue)="{ item }">
                <pre class="whitespace-pre-wrap break-all text-xs max-w-xs">{{
                    item.oldValue
                }}</pre>
            </template>
            <template #cell(value)="{ item }">
                <pre class="whitespace-pre-wrap break-all text-xs max-w-xs">{{
                    item.value
                }}</pre>
            </template>
            <template #cell(madeBy)="{ item }">
                <router-link
                    v-if="item.isPortal && item.madeBy"
                    :to="`/app/users/detail/${item.madeBy}`"
                    class="text-theme-primary underline"
                >
                    {{ item.madeBy }}
                </router-link>
                <span v-else>{{ item.madeBy }}</span>
            </template>
            <template #cell(details)="{ item }">
                <pre class="whitespace-pre-wrap break-all text-xs max-w-xs">{{
                    item.details
                }}</pre>
            </template>
        </custom-table>
    </app-dialog>
</template>

<script>
import {
    HISTORY_SOURCES,
    formatHistoryValue,
    resolveHistorySource,
    sortHistoryNewestFirst
} from "@/common/lib/order-history";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomTable from "@/components/utils/CustomTable.vue";

export default {
    name: "OrderHistoryDialog",
    components: { AppDialog, CustomTable },
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        metadata: {
            type: Array,
            default: () => []
        },
        orderId: {
            type: [Number, String],
            default: null
        }
    },
    data: () => ({
        fields: [
            { key: "date", label: "Fecha" },
            { key: "source", label: "Origen" },
            { key: "message", label: "Cambio" },
            { key: "oldValue", label: "Antes" },
            { key: "value", label: "Después" },
            { key: "madeBy", label: "Quién" },
            { key: "details", label: "Detalles" }
        ]
    }),
    computed: {
        rows() {
            return sortHistoryNewestFirst(this.metadata).map((entry) => {
                const source = resolveHistorySource(entry);
                return {
                    date: entry.date,
                    source,
                    message: entry.message,
                    oldValue: formatHistoryValue(entry.oldValue),
                    value: formatHistoryValue(entry.value),
                    madeBy: entry.madeBy || "",
                    isPortal: source === HISTORY_SOURCES.portal,
                    details: formatHistoryValue(entry.details)
                };
            });
        }
    },
    methods: {
        emitInput(value) {
            this.$emit("input", value);
        },
        emitClose() {
            this.$emit("close");
        }
    }
};
</script>
